(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      // Zapewniamy, że w DOM istnieje dokładnie jedna instancja szuflady koszyka
      const allDrawers = Array.from(document.querySelectorAll('side-drawer[data-drawer="cart"]'));
      if (allDrawers.length > 1) {
        for (let i = 1; i < allDrawers.length; i++) {
          allDrawers[i].remove();
        }
      }

      const cartDrawer = document.querySelector('side-drawer[data-drawer="cart"]');
      if (!cartDrawer) return;

      if (cartDrawer._cartDrawerBound) return;
      cartDrawer._cartDrawerBound = true;

      const rootUrl = () => window.Shopify?.routes?.root || '/';

      const openDrawer = () => {
        const drawer = document.querySelector('side-drawer[data-drawer="cart"]');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
      };

      let refreshRequest = null;
      let currentDiscountStatus = {
        code: '',
        text: '',
        color: '',
        visible: false
      };

      const refreshDrawer = async () => {
        const currentInner = document.querySelector('side-drawer[data-drawer="cart"] [data-cart-drawer-inner]');
        if (!currentInner) return;
        if (refreshRequest) return refreshRequest;

        const cartUrl = `${rootUrl()}cart?_t=${Date.now()}`;

        refreshRequest = fetch(cartUrl, { cache: 'no-store' })
          .then((response) => {
            if (!response.ok) throw new Error('cart_fetch_failed');
            return response.text();
          })
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const fetchedInner = doc.querySelector('[data-cart-drawer-inner]') || doc.querySelector('form[action*="/cart"]') || doc.querySelector('.cart__items');
            
            if (fetchedInner && currentInner) {
              // Zachowaj stan wpisanego kodu i paczkomatu przed podmianą HTML
              const oldInput = currentInner.querySelector('[data-cart-discount-input]');
              const oldPaczkomat = currentInner.querySelector('[data-inpost-locker-input]');

              const inputVal = oldInput ? oldInput.value : '';
              const paczkomatVal = oldPaczkomat ? oldPaczkomat.value : '';

              currentInner.innerHTML = fetchedInner.innerHTML;

              // Przywróć aktywny komunikat rabatu ze stanu
              if (currentDiscountStatus.visible && currentDiscountStatus.text) {
                const newMsg = currentInner.querySelector('[data-cart-discount-message]');
                if (newMsg) {
                  newMsg.hidden = false;
                  newMsg.style.display = 'block';
                  newMsg.style.color = currentDiscountStatus.color;
                  newMsg.textContent = currentDiscountStatus.text;
                }
              }
              if (inputVal) {
                const newInput = currentInner.querySelector('[data-cart-discount-input]');
                if (newInput) newInput.value = inputVal;
              }
              if (paczkomatVal) {
                const newPaczkomat = currentInner.querySelector('[data-inpost-locker-input]');
                if (newPaczkomat && !newPaczkomat.value) newPaczkomat.value = paczkomatVal;
              }
            }
          })
          .catch((err) => {
            console.error('Błąd odświeżania szuflady:', err);
          })
          .finally(() => {
            refreshRequest = null;
          });

        return refreshRequest;
      };

      const removeLine = async (variantId) => {
        const response = await fetch(`${rootUrl()}cart/change.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 }),
        });
        if (!response.ok) return;
        const cart = await response.json();
        await refreshDrawer();
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      };

      // ==========================================
      // WSPÓLNA OBSŁUGA KODÓW RABATOWYCH (DRAWER + KOSZYK)
      // ==========================================
      const applyCartDiscount = async (code, specificContainer) => {
        const getContainers = () => specificContainer
          ? [specificContainer]
          : Array.from(document.querySelectorAll('[data-cart-discount], [data-cart-summary]'));

        let cleanCode = (code || '').trim();
        if (!cleanCode) {
          for (const c of getContainers()) {
            const val = c.querySelector('[data-cart-discount-input]')?.value?.trim();
            if (val) { cleanCode = val; break; }
          }
        }
        if (!cleanCode) return;

        currentDiscountStatus = {
          code: cleanCode,
          text: 'Sprawdzanie kodu...',
          color: 'var(--color-foreground)',
          visible: true
        };

        // Pokaż stan sprawdzania we wszystkich polach rabatowych
        getContainers().forEach(c => {
          const btn = c.querySelector('[data-cart-discount-apply]');
          const msg = c.querySelector('[data-cart-discount-message]');
          const inp = c.querySelector('[data-cart-discount-input]');
          if (btn) btn.disabled = true;
          if (inp && !inp.value) inp.value = cleanCode;
          if (msg) {
            msg.hidden = false;
            msg.style.display = 'block';
            msg.style.color = currentDiscountStatus.color;
            msg.textContent = currentDiscountStatus.text;
          }
        });

        try {
          const response = await fetch(`${rootUrl()}cart/update.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: cleanCode })
          });

          if (!response.ok) throw new Error('network_error');

          const cart = await response.json();
          const codeObj = Array.isArray(cart.discount_codes)
            ? cart.discount_codes.find(d => d.code && d.code.toLowerCase() === cleanCode.toLowerCase())
            : null;

          const isApplicable = codeObj
            ? codeObj.applicable
            : (cart.total_discount > 0 || (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0));

          if (isApplicable) {
            currentDiscountStatus = {
              code: cleanCode,
              text: `Kod "${cleanCode}" został zastosowany!`,
              color: '#2e7d32',
              visible: true
            };
          } else {
            currentDiscountStatus = {
              code: cleanCode,
              text: 'Niepoprawny lub nieaktywny kod rabatowy.',
              color: '#d32f2f',
              visible: true
            };
          }

          getContainers().forEach(c => {
            const btn = c.querySelector('[data-cart-discount-apply]');
            const msg = c.querySelector('[data-cart-discount-message]');
            const inp = c.querySelector('[data-cart-discount-input]');
            if (btn) btn.disabled = false;

            if (msg) {
              msg.style.color = currentDiscountStatus.color;
              msg.textContent = currentDiscountStatus.text;
              msg.hidden = false;
              msg.style.display = 'block';
            }
            if (isApplicable && inp) inp.value = '';
          });

          if (isApplicable) {
            window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          } else {
            fetch(`${rootUrl()}cart/update.js`, {
              method: 'POST',
              headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: '' })
            }).catch(() => null);

            document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
          }
        } catch (e) {
          currentDiscountStatus = {
            code: cleanCode,
            text: 'Niepoprawny kod rabatowy.',
            color: '#d32f2f',
            visible: true
          };
          getContainers().forEach(c => {
            const btn = c.querySelector('[data-cart-discount-apply]');
            const msg = c.querySelector('[data-cart-discount-message]');
            if (btn) btn.disabled = false;
            if (msg) {
              msg.style.color = currentDiscountStatus.color;
              msg.textContent = currentDiscountStatus.text;
              msg.hidden = false;
              msg.style.display = 'block';
            }
          });
        }
      };

      window.applyCartDiscount = applyCartDiscount;

      // Odświeżamy zawartość przy otwarciu szuflady
      cartDrawer.addEventListener('drawer:opened', () => {
        refreshDrawer();
      });

      // Zdarzenia globalne dla koszyka (rejestrowane tylko raz)
      if (!window.__cartDrawerGlobalsBound) {
        window.__cartDrawerGlobalsBound = true;

        // Czyszczenie komunikatów błędu podczas pisania
        document.addEventListener('input', (event) => {
          const input = event.target instanceof Element ? event.target.closest('[data-cart-discount-input]') : null;
          if (!input) return;
          const container = input.closest('[data-cart-discount]') || input.closest('[data-cart-summary]');
          const msg = container?.querySelector('[data-cart-discount-message]');
          if (msg) {
            msg.hidden = true;
            msg.style.display = 'none';
          }
        });

        // Kliknięcia (usuwanie produktu oraz aplikowanie rabatu)
        document.addEventListener('click', (event) => {
          const target = event.target instanceof Element ? event.target : null;
          if (!target) return;

          // 1. Usuwanie produktu
          const removeBtn = target.closest('[data-cart-line-remove]');
          if (removeBtn) {
            const currentDrawer = document.querySelector('side-drawer[data-drawer="cart"]');
            if (currentDrawer && currentDrawer.contains(removeBtn)) {
              event.preventDefault();
              const variantId = removeBtn.dataset.variantId;
              if (variantId) removeLine(variantId);
              return;
            }
          }

          // 2. Przycisk rabatu
          const discountBtn = target.closest('[data-cart-discount-apply]');
          if (discountBtn) {
            event.preventDefault();
            const container = discountBtn.closest('[data-cart-discount]') || discountBtn.closest('[data-cart-summary]');
            applyCartDiscount(null, container);
          }
        });

        // Klawisz Enter w polu rabatu
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            const input = event.target instanceof Element ? event.target.closest('[data-cart-discount-input]') : null;
            if (input) {
              event.preventDefault();
              const container = input.closest('[data-cart-discount]') || input.closest('[data-cart-summary]');
              applyCartDiscount(null, container);
            }
          }
        });

        window.addEventListener('cart:open', async () => {
          await refreshDrawer();
          openDrawer();
        });

        window.addEventListener('cart:updated', () => {
          refreshDrawer();
        });

        // Automatyczne sprawdzanie kodu z URL (?discount=) lub ciasteczka Shopify (discount_code=)
        const checkAutoDiscount = () => {
          let code = null;
          try {
            const urlParams = new URLSearchParams(window.location.search);
            code = urlParams.get('discount');
          } catch (e) {}

          if (!code) {
            const match = document.cookie.match(/(?:^|;s*)discount_code=([^;]+)/);
            if (match) code = decodeURIComponent(match[1]);
          }

          if (code) {
            applyCartDiscount(code);
          }
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', checkAutoDiscount, { once: true });
        } else {
          checkAutoDiscount();
        }


        // Przechwytywanie zapytań fetch dla dodania do koszyka (np. Quick Add)
        const originalFetch = window.fetch;
        if (originalFetch) {
          window.fetch = async function(...args) {
            const response = await originalFetch.apply(this, args);
            
            try {
              const url = args[0];
              const urlString = typeof url === 'string' ? url : (url && url.url ? url.url : '');
              
              if (urlString && urlString.includes('/cart/add')) {
                const resClone = response.clone();
                const data = await resClone.json().catch(() => null);
                
                if (data) {
                  setTimeout(async () => {
                    await refreshDrawer();
                    openDrawer();
                  }, 200);
                }
              }
            } catch (e) {
              // Ignoruj błędy
            }

            return response;
          };
        }
      }
    };

    if (customElements.get('side-drawer')) {
      init();
    } else {
      customElements.whenDefined('side-drawer').then(init);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-price-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    const initPriceFilter = (filterRoot) => {
      if (filterRoot.dataset.priceFilterReady === 'true') return;
      filterRoot.dataset.priceFilterReady = 'true';

      const minRange = filterRoot.querySelector('[data-price-min-range]');
      const maxRange = filterRoot.querySelector('[data-price-max-range]');
      const minInput = filterRoot.querySelector('[data-price-min-input]');
      const maxInput = filterRoot.querySelector('[data-price-max-input]');
      const minLabel = filterRoot.querySelector('[data-price-min-label]');
      const maxLabel = filterRoot.querySelector('[data-price-max-label]');
      const slider = filterRoot.querySelector('[data-price-slider]');
      const submitBtn = filterRoot.querySelector('[data-price-submit]');
      if (!minRange || !maxRange || !minInput || !maxInput) return;

      const currency = filterRoot.dataset.currencySymbol || '';
      const appliedMin = Number(filterRoot.dataset.appliedMin);
      const appliedMax = Number(filterRoot.dataset.appliedMax);
      const formatMoney = (value) => `${value}\u00a0${currency}`;

      const sync = (source) => {
        let minVal = Number(minRange.value);
        let maxVal = Number(maxRange.value);
        if (minVal > maxVal) {
          if (source === minRange) minVal = maxVal;
          else maxVal = minVal;
          minRange.value = String(minVal);
          maxRange.value = String(maxVal);
        }
        minInput.value = String(minVal);
        maxInput.value = String(maxVal);
        if (minLabel) minLabel.textContent = formatMoney(minVal);
        if (maxLabel) maxLabel.textContent = formatMoney(maxVal);

        const minBound = Number(minRange.min);
        const maxBound = Number(minRange.max);
        const span = Math.max(maxBound - minBound, 1);
        const minRatio = (minVal - minBound) / span;
        const maxRatio = (maxVal - minBound) / span;
        if (slider) {
          slider.style.setProperty('--price-min', String(minRatio));
          slider.style.setProperty('--price-max', String(maxRatio));
        }

        const mid = (minRatio + maxRatio) / 2;
        minRange.style.zIndex = minRatio > mid - 0.01 ? '5' : '3';
        maxRange.style.zIndex = maxRatio < mid + 0.01 ? '5' : '4';

        if (submitBtn) {
          const dirty = minVal !== appliedMin || maxVal !== appliedMax;
          submitBtn.classList.toggle('is-dirty', dirty);
        }
      };

      minRange.addEventListener('input', () => sync(minRange));
      maxRange.addEventListener('input', () => sync(maxRange));
      sync();
    };

    document.querySelectorAll('[data-price-filter]').forEach(initPriceFilter);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["horizontal-row-slider"] && !Shopify.designMode) return;
  try {
    class HorizontalRowSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-horizontal-row-track]');
      this.prevBtn = this.querySelector('[data-horizontal-row-prev]');
      this.nextBtn = this.querySelector('[data-horizontal-row-next]');
      this.centerWhenFit = this.hasAttribute('data-center-when-fit');
      if (!this.track) return;

      this.onResize = () => this.updateNav();

      this.prevBtn?.addEventListener('click', () => this.scrollByPage(-1));
      this.nextBtn?.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', this.onResize, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });

      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.track);
      this.observeItems();

      this.mutationObserver = new MutationObserver(() => {
        this.observeItems();
        this.updateNav();
      });
      this.mutationObserver.observe(this.track, { childList: true });

      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.updateNav());
      });
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      window.removeEventListener('resize', this.onResize);
    }

    observeItems() {
      this.track?.querySelectorAll('.horizontal-row__item').forEach((item) => {
        if (item.dataset.horizontalRowObserved) return;
        item.dataset.horizontalRowObserved = 'true';
        this.resizeObserver.observe(item);
      });
    }

    scrollByPage(direction) {
      if (!this.track) return;
      const item = this.track.querySelector('.horizontal-row__item');
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    hasOverflow() {
      const track = this.track;
      const tolerance = 2;

      if (track.scrollWidth - track.clientWidth > tolerance) return true;

      const items = track.querySelectorAll('.horizontal-row__item');
      if (items.length < 2) return false;

      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      let contentWidth = 0;

      items.forEach((item, index) => {
        contentWidth += item.getBoundingClientRect().width;
        if (index < items.length - 1) contentWidth += gap;
      });

      return contentWidth > track.clientWidth + tolerance;
    }

    updateNav() {
      if (!this.track) return;

      const canScroll = this.hasOverflow();
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = Math.max(0, scrollWidth - clientWidth);

      this.track.classList.toggle('is-scrollable', canScroll);
      if (this.centerWhenFit) {
        this.track.classList.toggle('is-centered', !canScroll);
      }

      if (this.prevBtn) this.prevBtn.hidden = !canScroll || scrollLeft <= 2;
      if (this.nextBtn) this.nextBtn.hidden = !canScroll || scrollLeft >= maxScroll - 2;
    }
  }

  if (!customElements.get('horizontal-row-slider')) {
    customElements.define('horizontal-row-slider', HorizontalRowSlider);
  }

  window.initHorizontalRowSliders = (root = document) => {
    root.querySelectorAll('horizontal-row-slider').forEach((slider) => {
      if (typeof slider.updateNav === 'function') slider.updateNav();
    });
  };

  window.initProductRowSliders = window.initHorizontalRowSliders;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const SOURCE_KEY = 'newsletter-form-source';

    const getVariant = (form) =>
      form.dataset.newsletterVariant ||
      (form.classList.contains('newsletter-form--modal') ? 'modal' : 'footer');

    const getSourceFromHash = () => {
      const hashId = window.location.hash.replace(/^#/, '');
      if (!hashId) return '';

      const form = document.getElementById(hashId);
      if (!form?.classList.contains('newsletter-form')) return '';

      return getVariant(form);
    };

    const resolveSource = () => sessionStorage.getItem(SOURCE_KEY) || getSourceFromHash() || '';

    const cleanNewsletterHash = () => {
      if (!window.location.hash) return;

      try {
        const url = new URL(window.location.href);
        url.hash = '';
        window.history.replaceState({}, '', url);
      } catch (_error) {}
    };

    const saveSource = (form) => {
      sessionStorage.setItem(SOURCE_KEY, getVariant(form));
    };

    const resetFormToInput = (form) => {
      form.querySelector('[data-newsletter-success]')?.setAttribute('hidden', '');
      form.querySelector('[data-newsletter-errors]')?.setAttribute('hidden', '');
      form.querySelector('[data-newsletter-fields]')?.removeAttribute('hidden');
      form.classList.remove('newsletter-form--has-feedback');
    };

    const formHasFeedback = (form) => {
      const success = form.querySelector('[data-newsletter-success]');
      const errors = form.querySelector('[data-newsletter-errors]');
      const successVisible = success && !success.hasAttribute('hidden');
      const errorsVisible =
        errors && !errors.hasAttribute('hidden') && errors.textContent.trim().length > 0;
      return successVisible || errorsVisible;
    };

    const openModalForForm = (form, focusTarget) => {
      const modal = form.closest('announcement-modal');
      if (!modal || typeof modal.open !== 'function') return;

      if (!modal.isOpen) {
        modal.open();
      }

      if (focusTarget) {
        window.requestAnimationFrame(() => {
          focusTarget.focus();
        });
      }
    };

    const initForm = (form) => {
      if (form.dataset.newsletterBound === 'true') return;
      form.dataset.newsletterBound = 'true';

      const submitButton = form.querySelector('[type="submit"]');
      submitButton?.addEventListener(
        'click',
        () => {
          saveSource(form);
        },
        true
      );

      form.addEventListener(
        'submit',
        () => {
          saveSource(form);
        },
        true
      );
    };

    const routePostedFeedback = () => {
      const source = resolveSource();
      const forms = [...document.querySelectorAll('.newsletter-form')];
      const hasAnyFeedback = forms.some(formHasFeedback);

      if (!hasAnyFeedback) {
        window.__newsletterFeedbackRouted = true;
        document.dispatchEvent(new CustomEvent('newsletter:feedback-routed'));
        return;
      }

      if (!source) {
        forms.forEach((form) => {
          if (getVariant(form) === 'modal') {
            resetFormToInput(form);
          }
        });
        window.__newsletterFeedbackRouted = true;
        document.dispatchEvent(new CustomEvent('newsletter:feedback-routed'));
        return;
      }

      let focusTarget = null;

      forms.forEach((form) => {
        const isSource = getVariant(form) === source;

        if (isSource) {
          const success = form.querySelector('[data-newsletter-success]');
          const errors = form.querySelector('[data-newsletter-errors]');
          const fields = form.querySelector('[data-newsletter-fields]');
          const hasSuccess = success && !success.hasAttribute('hidden');
          const hasErrors =
            errors && !errors.hasAttribute('hidden') && errors.textContent.trim().length > 0;

          if (hasSuccess) {
            fields?.setAttribute('hidden', '');
            focusTarget = success;
          }

          if (hasErrors) {
            focusTarget = errors;
          }

          form.classList.add('newsletter-form--has-feedback');
        } else {
          resetFormToInput(form);
        }
      });

      if (source === 'modal') {
        const modalForm = document.querySelector('.newsletter-form--modal.newsletter-form--has-feedback');
        if (modalForm) {
          openModalForForm(modalForm, focusTarget);
        }
      } else {
        focusTarget?.focus();
      }

      sessionStorage.removeItem(SOURCE_KEY);
      cleanNewsletterHash();
      window.__newsletterFeedbackRouted = true;
      document.dispatchEvent(new CustomEvent('newsletter:feedback-routed'));
    };

    const boot = () => {
      document.querySelectorAll('.newsletter-form').forEach(initForm);
      routePostedFeedback();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function(event) {
    var form = event.target.closest('.product-card-form');
    if (!form) return;

    event.preventDefault();
    var button = form.querySelector('.product-card__add-btn');
    var originalContent = button ? button.innerHTML : '';
    if (button) {
      button.innerHTML = '<span>Dodawanie...</span>';
      button.disabled = true;
    }

    var formData = new FormData(form);
    var data = {};
    formData.forEach(function(value, key) {
      data[key] = value;
    });
    if (!data.quantity) data.quantity = 1;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(result) {
      if (button) {
        button.innerHTML = originalContent;
        button.disabled = false;
      }

      return fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then(function(res) { return res.json(); })
        .then(function(sections) {
          var parser = new DOMParser();

          if (sections['cart-drawer']) {
            var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
            var newDrawer = doc.querySelector('cart-drawer');
            var currentDrawer = document.querySelector('cart-drawer');
            if (newDrawer && currentDrawer) {
              currentDrawer.innerHTML = newDrawer.innerHTML;
            }
          }

          if (sections['cart-icon-bubble']) {
            var doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
            var newBubble = doc.querySelector('#cart-icon-bubble');
            var currentBubble = document.querySelector('#cart-icon-bubble');
            if (newBubble && currentBubble) {
              currentBubble.innerHTML = newBubble.innerHTML;
            }
          }

          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            var cartIcon = document.querySelector('#cart-icon-bubble, .header__icon--cart');
            if (cartIcon) cartIcon.click();
          }
        });
    })
    .catch(function(error) {
      console.error('Błąd podczas dodawania do koszyka:', error);
      if (button) {
        button.innerHTML = originalContent;
        button.disabled = false;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.viewer = this.querySelector('[data-product-gallery-viewer]');
      this.slides = Array.from(this.querySelectorAll('[data-product-gallery-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-product-gallery-thumb]'));
      this.currentLabel = this.querySelector('[data-product-gallery-current]');
      this.dialog = this.querySelector('[data-product-gallery-dialog]');
      this.dialogImages = Array.from(this.querySelectorAll('[data-product-gallery-dialog-image]'));
      this.dialogCurrentLabel = this.querySelector('[data-product-gallery-dialog-current]');
      this.index = 0;
      this.dialogIndex = 0;

      this.querySelectorAll('[data-product-gallery-zoom-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => this.openDialog(Number(trigger.dataset.index) || 0));
      });

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.index) || 0));
      });

      this.viewer?.addEventListener('scroll', () => this.onViewerScroll(), { passive: true });

      this.querySelector('[data-product-gallery-close]')?.addEventListener('click', () => this.dialog?.close());
      this.querySelector('[data-product-gallery-dialog-prev]')?.addEventListener('click', (event) => {
        event.stopPropagation();
        this.stepDialog(-1);
      });
      this.querySelector('[data-product-gallery-dialog-next]')?.addEventListener('click', (event) => {
        event.stopPropagation();
        this.stepDialog(1);
      });
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.stepDialog(-1);
        if (event.key === 'ArrowRight') this.stepDialog(1);
      });
    }

    onViewerScroll() {
      if (!this.viewer) return;
      const width = this.viewer.clientWidth || 1;
      const index = Math.round(this.viewer.scrollLeft / width);
      this.setActive(index);
    }

    goTo(index) {
      const slide = this.slides[index];
      if (slide && this.viewer) {
        this.viewer.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      this.setActive(index);
    }

    setActive(index) {
      this.index = index;
      if (this.currentLabel) this.currentLabel.textContent = String(index + 1);
      this.thumbs.forEach((thumb) => thumb.classList.toggle('is-active', Number(thumb.dataset.index) === index));
    }

    openDialog(index) {
      if (!this.dialog) return;
      this.showDialogImage(index);
      this.dialog.showModal();
    }

    stepDialog(delta) {
      const total = this.dialogImages.length;
      if (!total) return;
      const next = (this.dialogIndex + delta + total) % total;
      this.showDialogImage(next);
    }

    showDialogImage(index) {
      this.dialogIndex = index;
      this.dialogImages.forEach((img) => {
        img.classList.toggle('is-active', Number(img.dataset.index) === index);
      });
      if (this.dialogCurrentLabel) this.dialogCurrentLabel.textContent = String(index + 1);
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    const initScrollReveal = () => {
    const sections = document.querySelectorAll('.scroll-reveal');

    if (!sections.length) {
      return;
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      sections.forEach((section) => {
        section.classList.add('is-visible');
      });
      return;
    }

    sections.forEach((section) => {
      section.classList.add('scroll-reveal--js');
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -5% 0px',
      }
    );

    sections.forEach((section) => {
      observer.observe(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }
  } catch(e) { console.error(e); }
})();

})();
